<template>
  <div :class="name">
    Not found
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'NotFound',
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue